export default {
  en: {
    chart: 'Bar chart',
  },
};
